import { z } from "zod";

export const schemaCentroDeCusto = z.object({
  cnCtRecStatus: z.any(),
  cnCtDescricao: z.string().min(1,"Descrição inválida."),
});

export type CentroDeCustoFormProps = z.infer<typeof schemaCentroDeCusto>;
